module.exports = __webpack_public_path__ + "static/2016-mTMZ-409a2b6aa70b8ee96a38d357b5d92692.pdf";